// src/TImerOnHeader/DaySessionAPI.js

import { axiosInstance } from '../../Services';

// Get current day session status
export const getDaySessionStatus = async () => {
  try {
    const res = await axiosInstance.get('/internal/DaySessions/status');
    return res;
  } catch (err) {
    throw err;
  }
};

// Start day session
export const startDaySession = async () => {
  try {
    const res = await axiosInstance.post('/internal/DaySessions/start');
    return res;
  } catch (err) {
    throw err;
  }
};

// Stop day session
export const stopDaySession = async () => {
  try {
    const res = await axiosInstance.post('/internal/DaySessions/stop');
    return res;
  } catch (err) {
    throw err;
  }
};
